<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="select" label="商品分类" name="user_name"></c-form-item>
					<c-form-item type="input" label="商品id" name="user_realname"></c-form-item>
					<c-form-item type="input" label="商品名称" name="department"></c-form-item>
					<c-form-item type="datetime" label="上架时间" name="phone"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="productState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" @click="selectClassify()">发布商品</c-button>
				<c-button color="black" hollow @click="soldHandle('in')">批量上架</c-button>
				<c-button color="black" hollow @click="soldHandle('out')">批量下架</c-button>
			</m-operate>
			
			<c-table ref="table" v-model="dataList">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
				>
					<template v-slot="{data}">
						{{productStateName[data.state]}}{{data.state}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商品id"
					name="product_id"
				>
				</c-table-column>
				
				<c-table-column
					label="商品名称"
					name="product_name"
				>
				</c-table-column>
				
				<c-table-column
					label="商品卖点"
					name="product_subtitle"
				>
				</c-table-column>
				
				<c-table-column
					label="所属分类"
					name="product_type_full_name"
				>
				</c-table-column>
				
				<c-table-column
					label="售价(元)"
					name="product_price"
				>
				</c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
				>
				</c-table-column>
				
				<c-table-column
					label="上下架时间"
					name="sell_state_date"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="210"
				>
					<template v-slot="{data}">
						<c-table-button key="1" @click="data.state = 0">编辑</c-table-button>
						<c-table-button key="2" v-if="data.state == 1" @click="data.state = 2">上架</c-table-button>
						<c-table-button key="3" v-if="data.state == 2" @click="data.state = 1">下架</c-table-button>
						<c-table-button key="4">{{data.state == 0 ? '草稿' : '正式'}}</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="classifySelector" title="选择商品类目" width="750" @resolve="createProduct" @close="getClassify(0)">
			<div class="classify-select flex-center">
				<dl v-for="(level, i) in productClassify" :key="i">
					<dt>
						<i class="tf tf-search"></i>
						<input v-model="classifySearch[i]" type="text" @keyup.enter="getClassify(i)">
					</dt>
					<dd>
						<ul>
							<li v-for="(item, j) in level" :key="j" class="flex-between-center" :class="{'z-crt': item == currentClassify[i]}" @click="classifyHandle(item, i)">
								<span>{{item.type_name}}</span>
								<i class="tf tf-angle-right"></i>
							</li>
						</ul>
					</dd>
				</dl>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_product_list',
		
		data() {
			return {
				productState: [{
					name: '草稿',
					value: 0
				}, {
					name: '上架',
					value: 2
				}, {
					name: '下架',
					value: 1
				}],
				
				productStateName: {
					0: '草稿',
					1: '下架',
					2: '上架'
				},
				
				dataList: [{
					id: 1,
					state: 1
				}, {
					id: 2,
					state: 2
				}, {
					id: 3,
					state: 2
				}],
				
				productClassify: [
					[], [], []
				],
				currentClassify: [],
				classifySearch: [],
				currentClassifyId: ''
			}
		},
		
		mounted() {
			this.$refs.search.search();
			
			this.$bus.$on('productList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
			},
			
			selectClassify() {
				if (!this.productClassify[0].length) {
					this.getClassify(0, 0);
				}
				this.$refs.classifySelector.open();
			},
			
			classifyHandle(item, level) {
				this.currentClassifyId = item.id;
				this.$set(this.currentClassify, level, item);
				if (level < 2) {
					this.getClassify(level+1);
				}
			},
			
			getClassify(level) {
				this.request({
					url: '/product_type/list',
					data: {
						type_name: this.classifySearch[level],
						parent_id: level ? this.currentClassify[level-1].id : 0
					},
					success: data => {
						if (!data) {
							this.$message({
								text: '未找到分类'
							});
							return;
						}
						this.$set(this.productClassify, level, data);
						for (let i=level; i<3; i++) {
							i > level && this.$set(this.productClassify, i, []);
							this.$set(this.currentClassify, i, undefined);
						}
						this.currentClassifyId = level ? this.currentClassify[level-1].id : '';
					}
				});
				this.$set(this.classifySearch, level, '');
			},
			
			createProduct(stop) {
				if (!this.currentClassifyId) {
					stop();
					this.$message({
						text: '请选择分类'
					});
					return;
				}
				this.navigateTo({
					path: '/product_apply',
					query: {
						classify: this.currentClassifyId
					}
				});
			},
			
			soldHandle(type, item) {
				var list = item ? [{
					data: item
				}] : this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
						text: '请选择要操作的商品'
					});
					return;
				}
				
				this.$confirm({
					text: `确定要${type == 'in' ? '上架' : '下架'}${item ? '该' : '所选'}商品吗？`,
					resolve: () => {
						this.request({
							url: '/product/sold',
							data: {
								type: type == 'in' ? 1 : 2,
								product_ids: Array.from(list, item => item.data.product_id)
							},
							loading: true,
							success: () => {
								list.forEach(item => {
									item.data.state = type == 'in' ? 2 : 1
								});
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.classify-select {
		padding: 10px;
		
		dl {
			width: 240px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
</style>